<div class="login-tries">
    <div class="close-modal" (click)="activeModal.close('')">
        x
    </div>

    <div class="title">
        {{title | lang}}
    </div>

    <div class="img">
        <img appImageSelector alt="mt-image" imageType="icon" imageKey="attention" width="70">
    </div>

    <div class="message">
        <span *ngFor="let m of message">{{m | pascalcase}} <br></span><br>
        <span *ngIf="emailLogin"> 
            <img class="img-contact" alt="mt-image" appImageSelector imageType="icon" imageKey="mail-contacto"> {{ emailLogin | lowercase }} </span>
    </div>

    <div class="button-group">
        <app-button class="action rounded shadowed" [text]="'accept'"
            (clickHandler)="activeModal.close('')"></app-button>
    </div>
</div>